import { render, staticRenderFns } from "./PostsAddUpdate.vue?vue&type=template&id=95055cca&scoped=true&"
import script from "./PostsAddUpdate.vue?vue&type=script&lang=js&"
export * from "./PostsAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PostsAddUpdate.vue?vue&type=style&index=0&id=95055cca&scoped=true&lang=css&"
import style1 from "./PostsAddUpdate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95055cca",
  null
  
)

export default component.exports